import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { storageKey } from '@constants/index'

import notification from '@stores/notification'

import { saveToken } from '@utils/cookies'
import { storage } from '@utils/storage'

import { LoadingScreen } from '@elements/loading-screen'

import { useOAuth } from '../hooks'

const OAuth2Callback: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { oauthToken, error } = useOAuth()

  useEffect(() => {
    if (error) {
      const errorMessage =
        error ===
        'The resource owner or authorization server denied the request.'
          ? 'Anda tidak memiliki akses ke aplikasi ini'
          : 'Terjadi kesalahan di SSO. Silakan kontak admin SSO'

      notification.error(errorMessage, 5000)
      navigate('/login')
      return
    }

    if (oauthToken) {
      try {
        storage.setItem(storageKey.authToken, `Bearer ${oauthToken}`)
        saveToken(oauthToken)
        const redirectPath = location?.state?.redirect || '/dashboard'
        navigate(redirectPath, { replace: true })
        notification.success('Login successful')
      } catch (err) {
        notification.error('Terjadi kesalahan saat menyimpan token')
        navigate('/login', { replace: true })
      }
    }
  }, [error, oauthToken, navigate, location])

  return <LoadingScreen reason='Completing OAuth2 authentication...' />
}

export default OAuth2Callback
